<h1 class="flex justify-between"><span>Applicant List</span><span>School Year: <span>{{schoolYear | schoolYear}}</span></span></h1>
<mat-divider></mat-divider>
<p>
    All applications for the current school-year are listed below.
    Click 'View' to see all application and student details (including course work).
    A checkmark in the Status column indicates the student has finalized their application.
    No icon indicates the application is incomplete.
</p>

<div class="w-fit mt-[20px] mr-auto ml-auto">
    <mat-form-field class="w-full">
        <mat-label>Search...</mat-label>
        <input matInput (keyup)="applyFilter($event)" [(ngModel)]="input">
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true" (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="FinalizedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Finalized Date</th>
            <td mat-cell *matCellDef="let row">
                <div>{{row.FinalizedDate | date: 'MMM d y'}}</div>
                <div>{{row.FinalizedDate | date: 'h:mmaaa'}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="StudentName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Student</th>
            <td mat-cell *matCellDef="let row">
                <div>{{row.StudentName}}</div>
                <div>{{row.StudentID}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="SchoolName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>School</th>
            <td mat-cell *matCellDef="let row">
                <div>{{row.SchoolName}}</div>
                <div>{{row.SchoolID}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="EmailUserName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let row">
                <span>{{row.EmailUserName}}</span>
                <wbr>
                <span>{{row.EmailDomainName}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="GPA">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>GPA</th>
            <td mat-cell *matCellDef="let row">{{row.GPA}}</td>
        </ng-container>
        <ng-container matColumnDef="SATCombined">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SAT</th>
            <td mat-cell *matCellDef="let row">
                <div>{{row.SATCombined}}</div>
                <div>{{row.SATValues}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="ACT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ACT</th>
            <td mat-cell *matCellDef="let row">{{row.ACT}}</td>
        </ng-container>
        <ng-container matColumnDef="CLT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CLT</th>
            <td mat-cell *matCellDef="let row">{{row.CLT}}</td>
        </ng-container>
        <ng-container matColumnDef="HoursCombined">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours</th>
            <td mat-cell *matCellDef="let row">
                <div>{{row.HoursCombined}}</div>
                <div>{{row.HoursValues}}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let row">
                @if (row.Status === 'C') {
                <mat-icon matTooltip="complete">done</mat-icon>
                }
                @if (row.Status === 'D') {
                <mat-icon matTooltip="disqualified">block</mat-icon>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let row">
                <div class="flex flex-wrap justify-center gap-[5px]">
                    <button mat-raised-button type="button" [routerLink]="['/summary', row.AppID]" class="p-[2px] min-w-0 h-[30px]" matTooltip="View application summary">
                        <mat-icon class="m-0">preview</mat-icon>
                    </button>
                    <button mat-raised-button type="button" (click)="downloadPDF(row)" class="p-[2px] min-w-0 h-[30px]" matTooltip="Download application summary">
                        <mat-icon class="m-0">download</mat-icon>
                    </button>
                    @if (row.Status === 'D') {
                    <button mat-raised-button type="button" (click)="undo(row.AppID)" class="p-[2px] min-w-0 h-[30px]" matTooltip="Undo disqualify">
                        <mat-icon class="m-0">undo</mat-icon>
                    </button>
                    }
                    @else {
                    <button mat-raised-button type="button" (click)="disqualify(row.AppID)" class="p-[2px] min-w-0 h-[30px]" matTooltip="Disqualify">
                        <mat-icon class="m-0">block</mat-icon>
                    </button>
                    }
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [ngClass]="{ evenRows: even }"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-red-500 text-center" colspan="10">No data found</td>
        </tr>
    </table>
    <mat-divider></mat-divider>
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 100, 500]" (page)="handlePageEvent($event)" [pageIndex]="pageIndex"></mat-paginator>
</div>
@if (user.RoleBooleans.IsDeveloper === true) {
<button mat-raised-button type="button" (click)="focusUpdate()">Get Updated Data From Focus</button>
}